import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import VideoPlayer from 'yoda-site-components/lib/components/VideoPlayer/VideoPlayer';
import * as styles from './InlineVideo.css';
import { videoPlayerAnalytics } from '../../actions/AnalyticsAction';
import VideoContainer from '../VideoContainer/VideoContainer';

const cx = classNames.bind(styles);

/* istanbul ignore next */
export class ProductVideos extends Component {
    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        videos: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        dataAutomationId: PropTypes.string,
        initCallBack: PropTypes.func,
        enableVideoPlacementChange: PropTypes.bool,
        isMarketPlaceProduct: PropTypes.bool,
        enableMarketPlace: PropTypes.bool,
    };

    static defaultProps = {
        actions: {},
        videos: [],
        dataAutomationId: null,
        initCallBack: null,
        enableVideoPlacementChange: false,
        isMarketPlaceProduct: false,
        enableMarketPlace: false,
    };

    constructor() {
        super();
        this.triggerAnalytics = this.triggerAnalytics.bind(this);
    }

    componentDidMount() {
        if (this.props.initCallBack) {
            this.props.initCallBack();
        }
    }

    triggerAnalytics(pageId) {
        const videoPlayerData = window.videojs(pageId);
        this.props.actions.videoPlayerAnalytics(videoPlayerData);
    }

    render() {
        const {
            videos,
            dataAutomationId,
            enableVideoPlacementChange,
            isMarketPlaceProduct,
            enableMarketPlace,
        } = this.props;
        const productVideoID = videos.id;
        const productVideoType = videos.type;
        const productVideoUrl = videos.url;
        const isMarketplaceVideo =
            enableMarketPlace && isMarketPlaceProduct && productVideoType !== 'Scene7';

        return (
            <div className={cx('productVideos')}>
                {productVideoType === 'Scene7' || isMarketplaceVideo ? (
                    <div id="productVideos" className={cx('videoParentContainer')}>
                        <div className={cx('videoChildContainer')}>
                            <VideoPlayer
                                url={productVideoUrl}
                                pageId="pdpVideo"
                                playerProps={{
                                    url: isMarketplaceVideo ? productVideoUrl : productVideoID,
                                }}
                                automationId={`${dataAutomationId}-${productVideoID}`}
                                triggerAnalytics={this.triggerAnalytics}
                                disableAutoPlay={!!enableVideoPlacementChange}
                                isPDP
                                isMarketplaceVideo={isMarketplaceVideo}
                            />
                        </div>
                    </div>
                ) : (
                    <div className={cx('defaultVideos')}>
                        <VideoContainer url={videos.url} />
                    </div>
                )}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ videoPlayerAnalytics }, dispatch),
});

export default connect(null, mapDispatchToProps)(ProductVideos);
